import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Dropdown, Form, Input, Modal } from "semantic-ui-react";

import { DBB_CUSTOMER_TYPE, DBB_CUSTOMER_TYPE_PER_APPOINTMENT_CUSTOMER } from "./../../../../modules/Appointments/common";
import AppService from "./../../../../modules/Appointments/service";
import "./DBBCreateContractModal.css";

const APPOINTMENT_CUSTOMER_FIELDS = ["customer_owner", "customer_contract", "customer_driver"];

const getDBBCustomerTypePair = (customerField, customerType) => `${customerField}:${customerType}`;

class DBBCreateContractModal extends Component {
  state = {
    selectedCustomerTypes: this.getDefaultCustomerTypes(),
    isSaving: false,
  };

  getDefaultCustomerTypes() {
    const { appointment } = this.props;

    return APPOINTMENT_CUSTOMER_FIELDS.filter(customerField => appointment[customerField]).map(customerField =>
      getDBBCustomerTypePair(customerField, DBB_CUSTOMER_TYPE_PER_APPOINTMENT_CUSTOMER[customerField])
    );
  }

  getCustomerName = customerField => {
    const customer = this.props.appointment[customerField];

    return `${customer.firstname || ""} ${customer.surname || ""}`.trim();
  };

  getCustomerTypeOptions = () => {
    const { appointment, t } = this.props;
    const { selectedCustomerTypes } = this.state;

    const customerTypeLabels = {
      [DBB_CUSTOMER_TYPE.OWNER]: t("dbb_customer_type_owner").message || "Owner",
      [DBB_CUSTOMER_TYPE.HOLDER]: t("dbb_customer_type_holder").message || "Holder",
      [DBB_CUSTOMER_TYPE.DRIVER]: t("dbb_customer_type_driver").message || "Driver",
      [DBB_CUSTOMER_TYPE.THIRD_PARTY]: t("dbb_customer_type_third_party").message || "Third party",
      [DBB_CUSTOMER_TYPE.INTERNAL]: t("dbb_customer_type_internal").message || "Internal",
      [DBB_CUSTOMER_TYPE.WARRANTY]: t("dbb_customer_type_warranty").message || "Warranty",
    };

    const customerRoleLabels = {
      customer_owner: t("owner").message || "Owner",
      customer_contract: t("contractor").message || "Contractor",
      customer_driver: t("driver").message || "Driver",
    };

    const takenCustomerTypes = selectedCustomerTypes.map(pair => pair.split(":")[1]);

    return APPOINTMENT_CUSTOMER_FIELDS.reduce((options, customerField) => {
      if (!appointment[customerField]) return options;

      const customerName = this.getCustomerName(customerField);

      options.push({
        icon: "user",
        key: customerField,
        value: customerField,
        text: customerName,
        description: customerRoleLabels[customerField],
        disabled: true,
      });

      Object.values(DBB_CUSTOMER_TYPE).forEach(customerType => {
        const pair = getDBBCustomerTypePair(customerField, customerType);

        options.push({
          key: pair,
          value: pair,
          text: customerTypeLabels[customerType],
          labelText: `${customerName} (${customerTypeLabels[customerType]})`,
          parentKey: customerField,
          disabled: !selectedCustomerTypes.includes(pair) && takenCustomerTypes.includes(customerType),
        });
      });

      return options;
    }, []);
  };

  handleChangeCustomerTypes = selectedCustomerTypes => this.setState({ selectedCustomerTypes });

  handleSave = () => {
    const { appointment, onCarUpdate, onError, onClose } = this.props;
    const { selectedCustomerTypes } = this.state;

    const customers = APPOINTMENT_CUSTOMER_FIELDS.reduce((customers, customerField) => {
      if (!appointment[customerField]) return customers;

      Object.values(DBB_CUSTOMER_TYPE).forEach(customerType => {
        if (selectedCustomerTypes.includes(getDBBCustomerTypePair(customerField, customerType))) customers[customerType] = appointment[customerField].id;
      });

      return customers;
    }, {});

    this.setState({ isSaving: true });

    AppService.createDBBContract({ appointment_id: appointment.id, customers })
      .then(result => {
        this.setState({ isSaving: false });

        if (!result?.data?.data) return onError("An unknown error occured, please try again");

        onCarUpdate({ ...appointment.car, ...result.data.data });
        onClose();
      })
      .catch(error => {
        this.setState({ isSaving: false });
        const errorMsg = error.response?.data?.errors?.[0] || "Error creating DBB contract";
        onError(errorMsg);
        console.warn("Error creating DBB contract", error);
      });
  };

  render() {
    const { appointment, open, onClose, t } = this.props;
    const { selectedCustomerTypes, isSaving } = this.state;

    return (
      <Modal size="tiny" open={open} onClose={onClose} closeOnDimmerClick={false} className="DBBCreateContractModal">
        <Modal.Header>{t("create_dbb_contract").message || "Create DBB contract"}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>{t("contract_type").message || "Contract type"}</label>
              <Input value={appointment.is_lease_company ? t("lease").message || "Lease" : t("private").message || "Private"} readOnly disabled />
            </Form.Field>

            <Form.Field>
              <label>{t("customers").message || "Customers"}</label>
              <Dropdown
                fluid
                selection
                multiple
                scrolling
                closeOnChange={false}
                selectOnBlur={false}
                placeholder={t("select_dbb_customer_types").message || "Select DBB customer types"}
                value={selectedCustomerTypes}
                options={this.getCustomerTypeOptions()}
                renderLabel={option => ({ content: option.labelText })}
                onChange={(_e, { value }) => this.handleChangeCustomerTypes(value)}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="grey" onClick={onClose}>
            {t("cancel").message || "Cancel"}
          </Button>
          <Button color="green" onClick={this.handleSave} disabled={isSaving || !selectedCustomerTypes.length} loading={isSaving}>
            {t("save").message || "Save"}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(DBBCreateContractModal);
